import { useBreakpointValue as useWrappedUseBreakpointValue } from '@chakra-ui/react';
export const useBreakpointValue = useWrappedUseBreakpointValue;